type KeyInput = Pick<
  KeyboardEvent,
  'key' | 'timeStamp' | 'metaKey' | 'ctrlKey' | 'altKey' | 'isComposing'
>;

export function createWordMatcher({
  word,
  gapMs,
}: {
  word: string;
  gapMs: number;
}) {
  const target = word.toLowerCase();
  const prefix = Array<number>(target.length).fill(0);
  for (let i = 1, j = 0; i < target.length; i += 1) {
    while (j && target[i] !== target[j]) j = prefix[j - 1];
    if (target[i] === target[j]) j += 1;
    prefix[i] = j;
  }
  let position = 0;
  let timestamp = 0;

  return (event: KeyInput): boolean => {
    if (
      event.isComposing ||
      event.key === 'Process' ||
      event.metaKey ||
      event.ctrlKey ||
      event.altKey
    ) {
      position = 0;
      return false;
    }
    if (['Shift', 'CapsLock'].includes(event.key)) return false;
    if (event.timeStamp - timestamp > gapMs) position = 0;
    timestamp = event.timeStamp;
    const key = event.key.toLowerCase();
    while (position && key !== target[position])
      position = prefix[position - 1];
    if (key === target[position]) position += 1;
    if (position && position === target.length) {
      position = 0;
      return true;
    }
    return false;
  };
}
